import React, { useState } from 'react';
import { Icon, Tooltip } from 'antd';

const CopyableText = ({ text , className}) => {
  const [tooltipText, setTooltipText] = useState('Copy');
  
  const handleCopy = () => {
    try{
        navigator.clipboard.writeText(text);
        setTooltipText('Copied!');
    }catch(err){
        console.log("error in copying the betcode");
    }
  };

  const handleMouseLeave = () => {
    setTooltipText('Copy');
  };

  return (
    <div>
      <span className={className}>{text}</span>
      {/* CHECK IF THE CLIPBOARD API IS SUPPORTED BY THE BROWSER, IF NOT NO NEED TO SHOW THE TOOLTIP AND THE COPY ICON */}
      {navigator && navigator.clipboard && <Tooltip title={tooltipText} overlayClassName="copy-text-tooltip" getPopupContainer={trigger => trigger.parentNode}>
        <Icon
          className="copy-icon"
          type="copy"
          onClick={handleCopy}
          onMouseLeave={handleMouseLeave}
        />
      </Tooltip>}
    </div>
  );
};

export default CopyableText;
